import React, { useState } from 'react';
import ReactGA from 'react-ga';
import { GA_TRACKING_LANDING_PAGE } from '../helpers/AppConsts';
import HeroSection from '../landing/HeroSection';
import SearchFilterBar from '../landing/SearchFilterBar';
import LatestResultsSection from '../landing/LatestResultsSection';
import UpcomingFixturesSection from '../landing/UpcomingFixturesSection';
import QuestionsSection from '../landing/QuestionsSection';
import FooterNew from '../footer/FooterNew';

const EventShow = () => {
  const [filterText, setFilterText] = useState('');

  // Google Analytics tracking
  ReactGA.ga('send', 'pageview', GA_TRACKING_LANDING_PAGE);

  return (
    <div>
      <HeroSection />

      <SearchFilterBar onFilterChange={setFilterText} />

      <LatestResultsSection filterText={filterText} />

      <UpcomingFixturesSection />

      <QuestionsSection />

      <FooterNew />
    </div>
  );
};

export default EventShow;
